import { configureStore } from "@reduxjs/toolkit";
import { appSlice } from "./slices/app";
import { userSlice } from "./slices/user";


export const store = configureStore({
  reducer: {
    app: appSlice.reducer,
    user: userSlice.reducer,
  },
  devTools: process.env.NODE_ENV === "development" ? true : false,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
